export const useLocalStorage = () => {
    const getItem = (key: string, defaultValue: any = null) => {
        if(!window) return;
        let value = localStorage.getItem(key);
        if(!value) return defaultValue;
        try {
            const res = JSON.parse(value as string);
            return res;
        }
        catch(e: any) {
            return value;
        }
    }

    const setItem = (key: string, value: string | object) => {
        if(!window) return;
        if(typeof value === 'object') value = JSON.stringify(value);
        localStorage.setItem(key, value);
    }

    const clear = () => {
        if(window) localStorage.clear();
    }

    const removeItem = (key: string) => {
        if(!window) return;
        if(!key) throw new Error('Please provide a valid key');
        localStorage.removeItem(key);
    }

    return {
        getItem,
        setItem,
        removeItem,
        clear,
    }
}